import React from 'react';
import './Info.css';

const About = () => {
    return (
        <div className="info-page">
            <header className="info-hero">
                <div className="container">
                    <span className="section-eyebrow">OUR STORY</span>
                    <h1 className="terminal-title">Powering India's Insurance Future</h1>
                    <p className="terminal-desc">Bharatinsurex is not just a platform; it's a movement towards elite financial security and technological transparency.</p>
                </div>
                <div className="info-hero-orb"></div>
            </header>

            <main className="info-container">
                <section className="info-content">
                    <h2>About Bharatinsurex</h2>
                    <p>At Bharatinsurex, we believe that insurance should be a shield, not a burden. Founded by a vision of absolute technological transparency and elite customer care, we are reshaping how 2 lakh+ Indians protect their most valuable assets.</p>
                    
                    <blockquote>"Our mission is to provide every Indian with the technological tools and professional insurance guidance they need to secure their future with absolute confidence."</blockquote>

                    <h3>The Bharatinsurex Strategy</h3>
                    <p>We combine the power of high-performance analytics with a 'Customer-First' human touch. Our specialized insurance algorithms ensure you find the most comprehensive coverage at the most competitive premiums — all in under 2 minutes.</p>



                    <h3>Our Core Principles</h3>
                    <ul>
                        <li><strong>Radical Transparency</strong>: No hidden clauses, no confusion. Absolute clarity in every policy.</li>
                        <li><strong>Elite Speed</strong>: From quote to claim, we prioritize your time with high-performance digital tools.</li>
                        <li><strong>Absolute Trust</strong>: Built on a foundation of reliability and deep industry expertise.</li>
                    </ul>
                </section>
            </main>
        </div>
    );
};

export default About;
